import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Heading from "../../../Components/Heading/Heading";
import TryFreeCTA from "../../../Components/TryFreeCTA/TryFreeCTA";
import { trackQaOpen } from "../../../utils/analytics";
import styles from "./FAQ.module.css";
import { TEMP_CRM_PIVOT } from "../../../config/tempCrmPivot";

const FAQ_KEYS_ALL = [
  { q: "faq.q1", a: "faq.a1" },
  { q: "faq.q2", a: "faq.a2" },
  { q: "faq.q3", a: "faq.a3" },
  { q: "faq.q4", a: "faq.a4" },
  { q: "faq.q5", a: "faq.a5" },
  { q: "faq.q6", a: "faq.a6" },
  { q: "faq.q7", a: "faq.a7" },
  { q: "faq.q8", a: "faq.a8" },
];

const FAQ_KEYS_PIVOT = [
  { q: "faq.q1", a: "tempPivot.faq.a1" },
  { q: "faq.q2", a: "tempPivot.faq.a2" },
  { q: "faq.q4", a: "tempPivot.faq.a4" },
  { q: "faq.q6", a: "tempPivot.faq.a6" },
  { q: "faq.q7", a: "faq.a7" },
  { q: "faq.q8", a: "faq.a8" },
];

const FAQ_KEYS = TEMP_CRM_PIVOT ? FAQ_KEYS_PIVOT : FAQ_KEYS_ALL;

const FAQ = () => {
  const { t, i18n } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const isRtl = i18n.language === "ar" || i18n.language === "he";

  return (
    <div
      className={`container ${styles.wrap}`}
      id="faq"
      dir={isRtl ? "rtl" : "ltr"}
      data-aos="fade-up"
      data-aos-duration="500"
    >
      <section className={styles.header}>
        <Heading text={t("faq.title")} />
      </section>
      <div className={styles.accordion}>
        {FAQ_KEYS.map(({ q, a }, index) => (
          <div
            key={q}
            className={`${styles.item} ${openIndex === index ? styles.itemOpen : ""}`}
          >
            <button
              type="button"
              className={styles.question}
              onClick={() => {
                const next = openIndex === index ? null : index;
                if (next !== null) trackQaOpen(FAQ_KEYS[index].q);
                setOpenIndex(next);
              }}
              aria-expanded={openIndex === index}
            >
              <span className={styles.questionText}>{t(q)}</span>
              <span className={styles.chevron} aria-hidden>▼</span>
            </button>
            <div className={styles.answerWrap}>
              <div className={styles.answer}>
                {/* Split on blank lines so the JSON copy can carry
                    multi-paragraph answers (e.g. "feature A: …\n\nfeature
                    B: …") and they render with the .answer p spacing
                    the CSS already defines. */}
                {t(a).split(/\n\n+/).map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <TryFreeCTA section="faq" />
    </div>
  );
};

export default FAQ;
